import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constants/socialLinks";

const FooterLinks = () => {
  return (
    <div className="flex flex-wrap justify-center ">
      <Link
        to={ROUTES.PRIVACY_POLICY}
        className="px-4 py-2 text-light rounded hover:bg-opacity-80 transition-opacity hover:underline"
      >
        سياسة الخصوصية
      </Link>
      <Link
        to={ROUTES.TERMS_AND_CONDITIONS}
        className="px-4 py-2 text-light rounded hover:bg-opacity-80 transition-opacity hover:underline"
      >
        الشروط والأحكام
      </Link>
    </div>
  );
};

export default FooterLinks;